export default "__VITE_ASSET__BBV4r6lN__"